import {
    Accordion as AccordionChakra,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Text,
    Flex,
  } from '@chakra-ui/react'
import { ReactNode } from 'react';

type AccordionProps = {
    label?: string;
    children?: ReactNode
    labelColor?: string;
}

const Accordion = ({label, labelColor= 'black', children}: AccordionProps) => {
    return (
        <AccordionChakra allowToggle>
        <AccordionItem>
          <h2>
            <AccordionButton color='#3498FE'>
              <Flex flex='1' align='center' justifyContent='space-between' textAlign='left'>
                <Text fontSize='16px' fontFamily='Montserrat' fontWeight={500} color={labelColor}>{label}</Text>
              <AccordionIcon />
              </Flex>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            {children}
          </AccordionPanel>
        </AccordionItem>
        </AccordionChakra>
    );
}

export {Accordion};